<template>
  <div>
    <Draggable
      v-if="$store.state.voip.isShowWidget === true"
      class="mc-widget-call__container"
      :class="{ collapsed: isCollapsed }"
      :style="{ bottom: isDrag ? 'auto' : undefined }"
      @drag="(e) => onDrag(e)"
      @mousedown="(e) => onMouseDown(e)"
      @mouseup="onMouseUp"
    >
      <template #header>
        <div class="mc-widget-call__header" :class="{ 'grab-active': isGrabbing }">
          <h3 class="mc-widget-call__header-title">
            {{ $t('trackVideo.vehicleCommunication') }}
          </h3>
          <a
            href="#"
            class="mc-widget-call__header-expand"
            :class="isCollapsed ? 'mc-expand' : 'mc-collapse'"
            @click="toggleCollapsed()"
          >
            <i class="mc-fa icon-fill_expand"></i>
            <i class="mc-fa icon-outline_collapse"></i>
          </a>
        </div>
      </template>
      <div
        class="mc-widget-call__main-container"
        :class="{ collapsed: isCollapsed }"
        :style="{ 'max-height': isCollapsed ? '0px' : '190px' }"
      >
        <CallItem
          v-for="vehicleId in Object.keys(calls)"
          :ref="`voip-${vehicleId}`"
          :key="vehicleId"
          :licensePlate="calls[vehicleId].licensePlate"
          :driver="calls[vehicleId].driver"
          :callState="calls[vehicleId].state"
          :vehicleId="Number(vehicleId)"
          :imei="calls[vehicleId].imei"
          :token="calls[vehicleId].token"
          :deviceType="calls[vehicleId].deviceType"
          :muted="calls[vehicleId].isMuted"
          :entryPoint="calls[vehicleId].entryPoint"
          :audioContext="audioContext"
          @setCallsValue="setCallsValue"
        />
      </div>
      <EndCall
        v-if="sumCallsActive > 0"
        @clickEndCall="clickEndCall"
        @clickToggleMuted="clickToggleMuted"
      />
    </Draggable>
  </div>
</template>

<script>
import Draggable from '@/components/draggable.vue'
import EndCall from './CallItemState/EndCall.vue'
import CallItem from './CallItem.vue'
import { Helper } from '@/mixin/helper'
import KJUR from 'jsrsasign'
import { mapGetters } from 'vuex'

export default {
  components: {
    Draggable,
    EndCall,
    CallItem,
  },
  mixins: [Helper],
  data() {
    return {
      calls: {},
      isDrag: false,
      isGrabbing: false,
      audioContext: null,
    }
  },
  computed: {
    ...mapGetters('voip', ['sumCallsActive', 'vehicleIdsCallActive']),
    isCollapsed() {
      return this.$store.state.voip.isCollapsed
    },
  },
  watch: {
    sumCallsActive(val) {
      if (val === 0) {
        this.$store.commit('voip/setIsShowWidget', false)
        this.audioContext.close()
      } else {
        this.audioContext = new AudioContext()
        this.$store.commit('voip/setIsMuted', false)
      }
    },
    async '$store.state.voip.calls'(calls, oldCalls) {
      this.delay(500)
      const vehicleIds = calls.map((call) => call.vehicleId)
      const isRemoved = oldCalls.length > calls.length
      if (isRemoved) {
        const vehicleIdRemoved = oldCalls
          .map((call) => call.vehicleId)
          .find((oldVehicleId) => !calls.some((call) => call.vehicleId === oldVehicleId))
        delete this.calls[vehicleIdRemoved]
      }
      for (let i = 0; i < vehicleIds.length; i++) {
        const _data = calls[i]
        const isNewCall = !oldCalls.map((call) => call.vehicleId).includes(_data.vehicleId)
        if (isNewCall) {
          const imei = _data.imei
          const header = { alg: 'HS256', typ: 'JWT' }
          const payload = { client_id: 'frontend_' + imei }
          const secret = process.env.VUE_APP_VOIP_JWT_SECRET
          const token = KJUR.jws.JWS.sign(header.alg, header, payload, secret)
          this.calls[vehicleIds[i]] = {
            ..._data,
            isMuted: false,
            state: 'connecting',
            token,
          }

          this.$store.commit('video/setVoipState', {
            vehicleId: vehicleIds[i],
            values: { state: 'connecting' },
          })
        }
        if (!isNewCall && calls.length > 1) {
          this.calls[vehicleIds[i]].isMuted = true
        }
      }

      this.$forceUpdate()
    },
  },

  methods: {
    onMouseDown() {
      this.isGrabbing = true
    },
    onMouseUp() {
      this.isGrabbing = false
    },
    onDrag() {
      if (!this.isDrag) {
        this.isDrag = true
      }
    },
    setCallsValue(vehicleId, key, value) {
      this.calls[vehicleId][key] = value
      this.$forceUpdate()
    },
    toggleCollapsed() {
      this.$store.commit('voip/setIsCollapsed', !this.isCollapsed)
    },
    clickEndCall() {
      const vehicleIds = Object.keys(this.calls)
      for (let i = 0; i < vehicleIds.length; i++) {
        const vehicleId = vehicleIds[i]
        const voipComponent = this.$refs[`voip-${vehicleId}`][0]
        voipComponent.stopCall()
      }
      this.$store.commit('video/resetVoipVehicleIdActive')
      this.$store.commit('video/resetVoipState')
    },
    clickToggleMuted() {
      const isMuted = this.$store.state.voip.isMuted
      const vehicleIds = Object.keys(this.calls)
      for (let i = 0; i < vehicleIds.length; i++) {
        const vehicleId = vehicleIds[i]
        const voipComponent = this.$refs[`voip-${vehicleId}`][0]
        voipComponent.toggleMuteMic(isMuted)
      }
    },
  },
}
</script>
